<div leaflet
     [leafletOptions]="options"
     (leafletMapReady)="onMapReady($event)"
     (leafletMapZoomEnd)="onMapZoomEnd($event)"
     id='waypoints-ods-map'
>
     <mat-dialog-actions align="end" style="position: absolute; top: 10px; right: 10px; z-index: 1000;" fxLayout="column">
        <h1 *ngIf="this.data" mat-dialog-title class="title" [ngStyle]="{'color': setColor(data.waypoint_percentage)}">% Completamento: {{ data.waypoint_percentage | number : '1.2-2' }} </h1>
          <button mat-button mat-dialog-close style="color: #fafafa; background-color: #3f51b5;" (click)="unsub()">Chiudi</button>
     </mat-dialog-actions>
</div>